import { type CaseStatus, isCaseDone } from "@/features/cases/types";

/**
 * Compact due indicator for case list/feed rows: "Overdue Nd" / "Today" /
 * "In Nd", or a muted dash when the case is done or has no due date. `days` is
 * the signed delta from today (negative = overdue).
 */
export function CaseDueBadge({
  status,
  days,
}: {
  status: CaseStatus;
  days: number | null;
}) {
  if (days === null || isCaseDone(status))
    return <span className="text-muted-foreground">—</span>;
  if (days < 0) return <span className="text-destructive font-medium">Overdue {-days}d</span>;
  if (days === 0) return <span className="text-destructive font-medium">Today</span>;
  return <span className="text-muted-foreground">In {days}d</span>;
}
